/* eslint-disable no-nested-ternary */
import BarChart from './bar-chart';
import './index.scss';
import {
  BarChartDetails,
  MetricsModule
} from '../../types/simulation-summary.model';
import '../../simulation-summary.scss';
import { ColorData, chartTypeMap } from '../../utils/constants';
import MetricsBarChartComponent from './metrics-bar-chart.component';
import TextInfo from './summary-text-component';

export default function BarChartComponent({
  chartData,
  barWidthValue,
  summaryMetrics,
  ColumnCount
}: {
  // chartData: BarChartDetails;
  chartData: BarChartDetails;
  barWidthValue: number;
  summaryMetrics: MetricsModule[];
  ColumnCount: number;
}) {
  const axisKeys = [
    {
      key: 'current',
      alias: 'Current',
      color: ColorData.greyColor
    },
    {
      key: 'new',
      alias: 'New',
      color: ColorData.primaryColor
    }
  ];

  return (
    <div className='chart-div' key={`chart_${chartData.metric}`} style={{width:`${140/ColumnCount}%`}}>
      <div style={{ marginTop: '5px' }} className='chart-title'>
        {chartData.alias}
      </div>
      <div className='legend-div'>
        <TextInfo
          barWidthValue={barWidthValue}
          barData={chartData}
          height={60}
          axisKeys={axisKeys}
          type={chartTypeMap.summaryChart}
        />
      </div>
      <MetricsBarChartComponent
        summaryMetrics={summaryMetrics}
        chartData={chartData}
        barWidthValue={barWidthValue}
      />
    </div>
  );
}
